var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.6432 6.6432H9.3568V1.3568C9.3568 0.607454 8.74935 0 8 0C7.25065 0 6.6432 0.607454 6.6432 1.3568V6.6432H1.3568C0.607454 6.6432 0 7.25065 0 8C0 8.74935 0.607454 9.3568 1.3568 9.3568H6.6432V14.6432C6.6432 15.3925 7.25065 16 8 16C8.74935 16 9.3568 15.3925 9.3568 14.6432V9.3568H14.6432C15.3925 9.3568 16 8.74935 16 8C16 7.25065 15.3925 6.6432 14.6432 6.6432Z",
    fill: "#292929"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoom_in.648ce40b8bb1c5c929f7881347dfd6f6.svg";
export { ForwardRef as ReactComponent };